export enum ProductionScheduleDisplay {
  DETAILVIEW,
  LISTVIEW,
  OVERVIEW
}
